var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"fs-14px me-2"},[_vm._v(_vm._s(_vm.$locale.globals.loading))]),_c('div',{staticClass:"background-image loading-icon w-30px h-30px"})])
}
var staticRenderFns = []

export { render, staticRenderFns }